module.exports = __webpack_public_path__ + "static/media/ic_launcher.4a09de46.png";